import { Controller } from "@hotwired/stimulus"

// Adds the page's current query params to the form's submission so filters owned by other
// forms on the page survive it; the form's own fields take precedence. Listens directly
// rather than via data-action because submit-on-change overwrites the element's data-action.
export default class extends Controller {
  connect() {
    this.element.addEventListener("formdata", this.merge)
  }

  disconnect() {
    this.element.removeEventListener("formdata", this.merge)
  }

  merge = (event) => {
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (!event.formData.has(key)) event.formData.append(key, value)
    })
  }
}
